(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["all-products-infinite"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('items-infinite-products')) {
    class ItemsInfiniteProducts extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('[data-items-infinite-grid]');
        this.status = this.querySelector('[data-items-infinite-status]');
        this.sentinel = this.querySelector('[data-items-infinite-sentinel]');
        this.fallback = this.querySelector('[data-items-infinite-fallback]');
        this.nextUrl = this.dataset.nextUrl;
        this.loading = false;
        this.autoPaused = false;
        this.loadNext = this.loadNext.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleFallbackClick = this.handleFallbackClick.bind(this);

        if (this.fallback) {
          this.fallback.hidden = true;
          this.fallback.addEventListener('click', this.handleFallbackClick);
        }

        if ('IntersectionObserver' in window && this.nextUrl && this.sentinel) {
          this.observer = new IntersectionObserver(
            (entries) => {
              if (entries[0].isIntersecting) this.loadNext();
            },
            { rootMargin: '600px 0px' }
          );
          this.observer.observe(this.sentinel);
        } else if (this.nextUrl) {
          window.addEventListener('scroll', this.handleScroll, { passive: true });
          this.handleScroll();
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        window.removeEventListener('scroll', this.handleScroll);
        this.fallback?.removeEventListener('click', this.handleFallbackClick);
      }

      handleScroll() {
        if (this.sentinel?.getBoundingClientRect().top < window.innerHeight + 600) this.loadNext();
      }

      handleFallbackClick(event) {
        event.preventDefault();
        this.autoPaused = false;
        this.fallback.hidden = true;
        this.loadNext();
      }

      async loadNext() {
        if (this.loading || !this.nextUrl || this.autoPaused) return;
        this.loading = true;
        this.setAttribute('data-loading', '');
        this.setAttribute('aria-busy', 'true');
        this.status.textContent = this.dataset.loadingText;
        if (this.fallback) this.fallback.hidden = true;

        try {
          const url = new URL(this.nextUrl, window.location.origin);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url.toString(), {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          });

          if (!response.ok) throw new Error(String(response.status));

          const html = await response.text();
          const documentFragment = new DOMParser().parseFromString(html, 'text/html');
          const nextSection = documentFragment.querySelector('items-infinite-products');

          if (!nextSection) throw new Error('missing-section');

          const nextItems = nextSection.querySelectorAll('[data-items-infinite-grid] > .grid__item');
          const fragment = document.createDocumentFragment();
          nextItems.forEach((item) => fragment.appendChild(item));
          this.grid.appendChild(fragment);

          this.nextUrl = nextSection.dataset.nextUrl || '';
          this.dataset.nextUrl = this.nextUrl;
          this.status.textContent = this.nextUrl ? this.dataset.loadedText : this.dataset.completeText;

          if (this.fallback && this.nextUrl) {
            this.fallback.href = this.nextUrl;
          }

          if (!this.nextUrl) {
            this.observer?.disconnect();
            window.removeEventListener('scroll', this.handleScroll);
            this.fallback?.remove();
          }
        } catch (error) {
          this.autoPaused = true;
          this.status.textContent = this.dataset.errorText;
          if (this.fallback) {
            this.fallback.href = this.nextUrl;
            this.fallback.hidden = false;
          }
        } finally {
          this.loading = false;
          this.removeAttribute('data-loading');
          this.setAttribute('aria-busy', 'false');
        }
      }
    }

    customElements.define('items-infinite-products', ItemsInfiniteProducts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instachina-shop"] && !Shopify.designMode) return;
  try {
    
  class InstaChinaShop extends HTMLElement {
    connectedCallback() {
      this.feed = this.querySelector('[data-instachina-feed]');
      this.categoryButtons = Array.from(this.querySelectorAll('[data-instachina-category]'));
      this.addedLabel = this.dataset.addedLabel;
      this.errorLabel = this.dataset.errorLabel;
      this.shareLabel = this.dataset.shareLabel;

      this.categoryButtons.forEach((button) => {
        button.addEventListener('click', () => this.showCollection(button.dataset.instachinaCategory));
      });

      this.querySelectorAll('[data-instachina-minus]').forEach((button) => {
        button.addEventListener('click', () => this.changeQuantity(button, -1));
      });

      this.querySelectorAll('[data-instachina-plus]').forEach((button) => {
        button.addEventListener('click', () => this.changeQuantity(button, 1));
      });

      this.querySelectorAll('[data-instachina-form]').forEach((form) => {
        form.addEventListener('submit', (event) => this.addToCart(event));
      });

      this.querySelectorAll('[data-instachina-share]').forEach((button) => {
        button.addEventListener('click', () => this.shareProduct(button));
      });

      this.showCollection(this.categoryButtons[0]?.dataset.instachinaCategory, false);
      this.observeCards();
    }

    showCollection(id, focusFeed = true) {
      if (!id || !this.feed) return;

      this.querySelectorAll('[data-instachina-card]').forEach((card) => {
        const visible = card.dataset.instachinaCollection === id;
        card.hidden = !visible;
        if (!visible) card.querySelector('video')?.pause();
      });

      this.categoryButtons.forEach((button) => {
        button.classList.toggle('is-active', button.dataset.instachinaCategory === id);
      });

      this.feed.scrollTo({ top: 0, behavior: 'auto' });
      if (focusFeed) this.feed.focus({ preventScroll: true });
    }

    changeQuantity(button, direction) {
      const input = button.closest('[data-instachina-form]')?.querySelector('[data-instachina-quantity]');
      if (!input) return;

      const minimum = Number(input.min || 1);
      const maximum = input.max ? Number(input.max) : Infinity;
      const step = Number(input.step || 1);
      const next = Math.min(maximum, Math.max(minimum, Number(input.value || minimum) + direction * step));
      input.value = String(next);
    }

    async addToCart(event) {
      event.preventDefault();
      const form = event.currentTarget;
      const button = form.querySelector('[data-instachina-add]');
      const label = form.querySelector('[data-instachina-add-label]');
      if (!button || button.disabled) return;

      const originalLabel = label.textContent;
      button.disabled = true;
      button.classList.add('is-loading');

      try {
        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form),
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || this.errorLabel);

        const cartResponse = await fetch(`${window.routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
        const cart = await cartResponse.json();
        this.updateCartCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'instachina', cartData: cart });
        }

        label.textContent = this.addedLabel;
        window.setTimeout(() => { label.textContent = originalLabel; }, 1400);
      } catch (error) {
        label.textContent = error instanceof Error ? error.message : this.errorLabel;
        window.setTimeout(() => { label.textContent = originalLabel; }, 2200);
      } finally {
        button.classList.remove('is-loading');
        button.disabled = false;
      }
    }

    updateCartCount(count) {
      this.querySelectorAll('[data-instachina-cart-count]').forEach((element) => {
        element.textContent = String(count || 0);
      });
    }

    async shareProduct(button) {
      const shareData = { title: button.dataset.title, url: button.dataset.url };
      if (navigator.share) {
        try {
          await navigator.share(shareData);
          return;
        } catch (error) {
          if (error instanceof DOMException && error.name === 'AbortError') return;
        }
      }

      try {
        await navigator.clipboard.writeText(shareData.url);
        button.setAttribute('aria-label', this.shareLabel);
      } catch (error) {
        window.location.href = shareData.url;
      }
    }

    observeCards() {
      if (!this.feed || !('IntersectionObserver' in window)) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target.querySelector('video');
            if (entry.isIntersecting) {
              const collectionId = entry.target.dataset.instachinaCollection;
              this.categoryButtons.forEach((button) => {
                button.classList.toggle('is-active', button.dataset.instachinaCategory === collectionId);
              });
              video?.play().catch(() => {});
            } else {
              video?.pause();
            }
          });
        },
        { root: this.feed, threshold: 0.6 }
      );

      this.querySelectorAll('[data-instachina-card]').forEach((card) => observer.observe(card));
    }
  }

  if (!customElements.get('instachina-shop')) {
    customElements.define('instachina-shop', InstaChinaShop);
  }

  } catch(e) { console.error(e); }
})();
})();
